import MuiDrawer, { DrawerProps as MuiDrawerProps } from '@mui/material/Drawer';
import React from 'react';

export interface DrawerProps extends MuiDrawerProps {}

export const Drawer = (props: DrawerProps) => {
  return <MuiDrawer {...props} />;
};
